import { createAction } from '@reduxjs/toolkit'

import { REFRESH_ACTION_TRANSITIONS } from 'onboarding/features/config'

export const refreshActionTransitions = createAction(REFRESH_ACTION_TRANSITIONS, () => {
  return { payload: null }
})
